import React, { useRef, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";

const Footer = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [fileName, setFileName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visitorLocation, setVisitorLocation] = useState(null);

  const SERVICE_ID = "service_x0qp7zc";
  const TEMPLATE_ID = "template_2s4894j";
  const PUBLIC_KEY = "tmTWW-hXcDhbB5j6e";

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        setVisitorLocation({
          city: data.city,
          country: data.country_name,
          ip: data.ip,
          region: data.region,
          postal: data.postal,
          latitude: data.latitude,
          longitude: data.longitude,
        });
      } catch (err) {
        console.error("Error fetching location:", err);
        setVisitorLocation({
          city: "Unknown",
          country: "Unknown",
          ip: "Unknown",
          region: "Unknown",
          postal: "Unknown",
        });
      }
    };

    fetchLocation();
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName("");
    }
  };

  const handleReset = () => {
    form.current.reset();
    setFileName("");
    setSubmitStatus(null);
    const fileInput = document.getElementById("fileUpload");
    if (fileInput) fileInput.value = "";
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const formData = new FormData(form.current);
    const name = formData.get("name");
    const organization = formData.get("organization");
    const email = formData.get("email");
    const mobile = formData.get("mobile");
    const brief = formData.get("brief");
    const attachment = formData.get("attachment");

    if (!name || !organization || !email || !mobile || !brief) {
      alert("❌ Please fill all required fields!");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("❌ Please enter a valid email address!");
      return;
    }

    setIsSubmitting(true);

    try {
      const emailFormData = new FormData();
      emailFormData.append("name", name);
      emailFormData.append("organization", organization);
      emailFormData.append("email", email);
      emailFormData.append("mobile", mobile);
      emailFormData.append("brief", brief);
      if (attachment) {
        emailFormData.append("attachment", attachment);
      }

      if (visitorLocation) {
        emailFormData.append("visitor_city", visitorLocation.city);
        emailFormData.append("visitor_country", visitorLocation.country);
        emailFormData.append("visitor_ip", visitorLocation.ip);
        emailFormData.append("visitor_region", visitorLocation.region);
        emailFormData.append("visitor_postal", visitorLocation.postal);
        emailFormData.append("submission_time", new Date().toLocaleString());
      } else {
        try {
          const response = await fetch("https://ipapi.co/json/");
          const data = await response.json();
          emailFormData.append("visitor_city", data.city || "Unknown");
          emailFormData.append("visitor_country", data.country_name || "Unknown");
          emailFormData.append("visitor_ip", data.ip || "Unknown");
          emailFormData.append("visitor_region", data.region || "Unknown");
          emailFormData.append("visitor_postal", data.postal || "Unknown");
          emailFormData.append("submission_time", new Date().toLocaleString());
        } catch (err) {
          emailFormData.append("visitor_city", "Unknown");
          emailFormData.append("visitor_country", "Unknown");
          emailFormData.append("visitor_ip", "Unknown");
          emailFormData.append("visitor_region", "Unknown");
          emailFormData.append("visitor_postal", "Unknown");
          emailFormData.append("submission_time", new Date().toLocaleString());
        }
      }

      const result = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        Object.fromEntries(emailFormData),
        PUBLIC_KEY
      );

      console.log("Email sent successfully:", result.text);
      alert("✅ Message sent successfully! We'll contact you soon.");
      handleReset();
      closeModal();
      
    } catch (error) {
      console.error("Email send error:", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openModal = (e) => {
    if (e) e.preventDefault();
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "unset";
    handleReset();
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isModalOpen) {
        closeModal();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isModalOpen]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
    script.async = true;
    script.onload = () => {
      if (window.AOS) {
        window.AOS.init({
          duration: 800,
          once: true,
          offset: 100,
        });
      }
    };
    document.body.appendChild(script);

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://unpkg.com/aos@2.3.1/dist/aos.css";
    document.head.appendChild(link);

    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
      if (document.head.contains(link)) document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <style>{`
        .fixed-tel {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 50px;
          height: 50px;
          line-height: 50px;
          z-index: 9999;
          text-align: center;
        }
        .fixed-tel:before {
          content: "";
          width: 50px;
          height: 50px;
          background-color: #ff5f13;
          position: absolute;
          border-radius: 100%;
          box-shadow: 0 1px 1.5px 0 rgba(0, 0, 0, .12), 0 1px 1px 0 rgba(0, 0, 0, .24);
          z-index: 1;
          top: 0;
          left: 0;
        }
        .fixed-tel i {
          vertical-align: middle;
          z-index: 2;
          position: relative;
          color: #030f27;
          font-size: 1.5rem;
        }
        .enquire-float {
          position: fixed;
          right: -66px;
          top: 70%;
          transform: translateY(-50%) rotate(-90deg);
          background: #0865c2;
          color: white;
          padding: 2px 10px;
          font-size: 20px;
          font-weight: 500;
          text-decoration: none;
          border-radius: 8px 8px 0 0;
          z-index: 1000;
          box-shadow: 0 4px 10px rgba(0,0,0,0.2);
          transition: all 0.3s ease;
          cursor: pointer;
          border: none;
        }
        .enquire-float:hover {
          background: #ffb300;
          color: #fff;
          right: -66px;
        }
        .form-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          z-index: 10000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;
          animation: fadeIn 0.3s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .modal-container {
          max-width: 1000px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          border-radius: 32px;
          position: relative;
          animation: modalPopIn 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          scrollbar-width: thin;
        }
        @keyframes modalPopIn {
          0% {
            opacity: 0;
            transform: scale(0.96) translateY(20px);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        .modal-close {
          position: sticky;
          top: 20px;
          right: 20px;
          float: right;
          background: white;
          border-radius: 50%;
          width: 42px;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
          z-index: 2100;
          transition: all 0.2s;
          border: 1px solid #e2e8f0;
          color: #1e293b;
          margin: 10px;
        }
        .modal-close:hover {
          background: #f1f5f9;
          transform: scale(1.05);
          color: #ef4444;
        }
        .form-wrapper {
          position: relative;
          background: #ffffff;
          border-radius: 32px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .form-wrapper:hover {
          box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.2);
        }
        .form-decoration {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          pointer-events: none;
          overflow: hidden;
        }
        .decoration-circle {
          position: absolute;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.05), rgba(118, 75, 162, 0.05));
        }
        .circle-1 {
          width: 300px;
          height: 300px;
          top: -150px;
          right: -100px;
        }
        .circle-2 {
          width: 200px;
          height: 200px;
          bottom: -80px;
          left: -80px;
        }
        .circle-3 {
          width: 150px;
          height: 150px;
          top: 40%;
          right: 10%;
        }
        .attractive-form {
          position: relative;
          padding: 5px 40px;
          z-index: 1;
        }
        .form-header-section {
          text-align: center;
          margin-bottom: 40px;
        }
        .form-badge {
          display: inline-block;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 6px 16px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .form-title {
          font-size: 2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
        }
        .form-subtitle {
          color: #64748b;
          font-size: 0.95rem;
        }
        .form-row {
          margin-bottom: 14px;
        }
        .form-row.three-columns {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .form-row.two-columns {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }
        .form-group {
          position: relative;
        }
        .form-group.full-width {
          grid-column: span 1;
        }
        .form-label {
          display: block;
          font-weight: 600;
          color: #334155;
          margin-bottom: 8px;
          font-size: 0.9rem;
        }
        .form-label i {
          color: #667eea;
          margin-right: 6px;
        }
        .required {
          color: #ef4444;
        }
        .form-input,
        .form-textarea {
          width: 100%;
          padding: 14px 18px;
          border: 2px solid #e2e8f0;
          border-radius: 16px;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          background: #f8fafc;
          font-family: inherit;
        }
        .form-textarea {
          resize: vertical;
          min-height: 70px;
        }
        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #667eea;
          background: #ffffff;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        }
        .input-focus-border {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          transition: width 0.3s ease;
        }
        .form-input:focus ~ .input-focus-border,
        .form-textarea:focus ~ .input-focus-border {
          width: 100%;
        }
        .file-upload-wrapper {
          position: relative;
        }
        .file-input {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
        }
        .file-label {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 20px;
          background: #f8fafc;
          border: 2px dashed #cbd5e1;
          border-radius: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          justify-content: center;
          font-weight: 500;
        }
        .file-label:hover {
          border-color: #667eea;
          background: #f1f5f9;
          color: #667eea;
        }
        .file-name {
          display: block;
          font-size: 0.8rem;
          color: #64748b;
          margin-top: 10px;
          text-align: center;
        }
        .toast-message {
          padding: 14px 20px;
          border-radius: 16px;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          gap: 10px;
          animation: slideIn 0.3s ease;
        }
        .toast-message.success {
          background: #ecfdf5;
          color: #059669;
          border-left: 4px solid #10b981;
        }
        .toast-message.error {
          background: #fef2f2;
          color: #dc2626;
          border-left: 4px solid #ef4444;
        }
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .form-actions {
          display: flex;
          gap: 16px;
          justify-content: flex-end;
          margin-top: 32px;
        }
        .btn-reset {
          padding: 12px 32px;
          background: transparent;
          border: 2px solid #e2e8f0;
          border-radius: 40px;
          font-weight: 600;
          color: #475569;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .btn-reset:hover {
          border-color: #667eea;
          color: #667eea;
          background: #f8fafc;
          transform: translateY(-2px);
        }
        .btn-submit {
          padding: 12px 36px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 40px;
          font-weight: 600;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
        .btn-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px -5px rgba(102, 126, 234, 0.4);
        }
        .btn-submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        @media (max-width: 992px) {
          .form-row.three-columns {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
        }
        @media (max-width: 768px) {
          .attractive-form {
            padding: 24px;
          }
          .form-title {
            font-size: 1.5rem;
          }
          .form-row.three-columns {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .form-row.two-columns {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .form-group.full-width {
            grid-column: span 1;
          }
          .form-actions {
            flex-direction: column;
            gap: 12px;
          }
          .btn-reset,
          .btn-submit {
            width: 100%;
            justify-content: center;
          }
          .enquire-float {
            padding: 0.8rem 1.5rem;
            font-size: 0.9rem;
          }
          .enquire-float {
            position: fixed;
            right: -55px;
            top: 63%;
            bottom: auto;
            transform: translateY(-50%) rotate(-90deg);
            font-size: 16px;
            padding: 4px 12px;
            z-index: 9999;
          }
        }
        @media (max-width: 480px) {
          .form-input,
          .form-textarea {
            padding: 12px 14px;
          }
          .form-badge {
            font-size: 0.75rem;
          }
          .form-title {
            font-size: 1.3rem;
          }
        }
        .marquee-container {
          background: linear-gradient(135deg, #f8f9ff, #e8f0fe);
          border-radius: 50px;
          padding: 10px 0;
          margin: 0 auto 10px auto;
          box-shadow: 0 5px 20px rgba(32, 117, 207, 0.1);
        }
        .marquee-content {
          font-size: 18px;
          font-weight: 600;
          color: #ffff;
        }
        .marquee-content i {
          color: #ffb300;
          margin: 0 10px;
          animation: bounce 1s ease-in-out infinite;
        }
        @keyframes bounce {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(5px);
          }
        }
        .footer-main {
          background: linear-gradient(135deg, #1a5fa8 0%, #0d4a8a 50%, #0a3a6e 100%);
          position: relative;
          overflow: hidden;
        }
        .footer-main::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 70%);
          border-radius: 50%;
          pointer-events: none;
        }
        .footer-main::after {
          content: '';
          position: absolute;
          bottom: -30%;
          left: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0) 70%);
          border-radius: 50%;
          pointer-events: none;
        }
        .footer-heading {
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 1px;
          position: relative;
          display: inline-block;
          padding-bottom: 12px;
          margin-bottom: 1px;
        }
        .footer-heading::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 3px;
          background: linear-gradient(135deg, #ffd700, #ff8c00);
          border-radius: 3px;
          transition: width 0.3s ease;
        }
        .footer-heading:hover::after {
          width: 70px;
        }
        .footer-link li {
          opacity: 0;
          transform: translateX(-20px);
          animation: slideInLeft 0.5s ease forwards;
        }
        .footer-link li:nth-child(1) { animation-delay: 0.1s; }
        .footer-link li:nth-child(2) { animation-delay: 0.2s; }
        .footer-link li:nth-child(3) { animation-delay: 0.3s; }
        .footer-link li:nth-child(4) { animation-delay: 0.4s; }
        .footer-link li:nth-child(5) { animation-delay: 0.5s; }
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .footer-link a {
          position: relative;
          transition: all 0.3s ease;
          display: inline-block;
        }
        .footer-link a::before {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(135deg, #ffd700, #ff8c00);
          transition: width 0.3s ease;
        }
        .footer-link a:hover {
          transform: translateX(8px);
          color: #ffd700 !important;
        }
        .footer-link a:hover::before {
          width: 100%;
        }
        .contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
          transition: all 0.3s ease;
        }
        .contact-item:hover {
          transform: translateX(5px);
        }
        .contact-icon {
          width: 35px;
          height: 35px;
          background: rgba(255,255,255,0.15);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }
        .contact-item:hover .contact-icon {
          background: #ffd700;
          color: #1a5fa8;
          transform: rotate(360deg);
        }
        .whatsapp-float {
          position: fixed;
          bottom: 30px;
          right: 30px;
          width: 60px;
          height: 60px;
          background: #25d366;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 32px;
          box-shadow: 0 5px 20px rgba(37, 211, 102, 0.4);
          z-index: 1000;
          transition: all 0.3s ease;
          animation: pulse 2s infinite;
          text-decoration: none;
        }
        .whatsapp-float:hover {
          transform: scale(1.1);
          box-shadow: 0 8px 30px rgba(37, 211, 102, 0.6);
          color: white;
        }
        @keyframes pulse {
          0% {
            box-shadow: 0 5px 20px rgba(37, 211, 102, 0.4);
          }
          50% {
            box-shadow: 0 5px 30px rgba(37, 211, 102, 0.7);
          }
          100% {
            box-shadow: 0 5px 20px rgba(37, 211, 102, 0.4);
          }
        }
        .copyright {
          background: linear-gradient(135deg, #0a3a6e, #062a4a);
          border-top: 1px solid rgba(255,255,255,0.1);
        }
        @media (max-width: 768px) {
          .footer-heading::after {
            left: 50%;
            transform: translateX(-50%);
          }
          .footer-heading {
            text-align: center;
            display: block;
          }
          .whatsapp-float {
            width: 50px;
            height: 50px;
            font-size: 28px;
            bottom: 20px;
            right: 20px;
          }
          .marquee-content {
            font-size: 14px;
          }
        }
      `}</style>

      <div className="footer-main container-fluid pt-4 pb-1">
        <div className="container">
          <div className="row g-4">
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="information">
                <p className="text-white">
                  DigiOpen Services Pvt. Ltd. is a Pune-based IT company providing software development, ERP implementation, IT consulting, and digital transformation services. Founded in September 2023, we help organizations optimize business processes, improve operational efficiency, and achieve sustainable growth through innovative and reliable technology solutions.
                </p>
              </div>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-3">
              <div className="information">
                <h6 className="footer-heading text-uppercase text-white">
                  <i className="fas fa-link me-2"></i>Quick Links
                </h6>
                <ul className="list-unstyled footer-link mt-3">
                  <li className="mb-2">
                    <Link to="/about" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      About Us
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/industries" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Industries
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/career" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Career
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/contact" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-3">
              <div className="resources">
                <h6 className="footer-heading text-uppercase text-white">
                  <i className="fas fa-cogs me-2"></i>Services
                </h6>
                <ul className="list-unstyled footer-link mt-3">
                  <li className="mb-2">
                    <Link to="/businessconsulting" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Business Consulting
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/consulting" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      ERP Consulting
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/ERPimplementation" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      ERP Implementation
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/appdevelopment" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Mobile Development
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/productdevelopment" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Product Development
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/webdevelopment" className="text-white text-decoration-none">
                      <i className="fas fa-chevron-right me-2" style={{ fontSize: "10px" }}></i>
                      Web Development
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="contact">
                <h6 className="footer-heading text-uppercase text-white">
                  <i className="fas fa-address-card me-2"></i>Contact Us
                </h6>
                <div className="contact-info mt-3">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div className="contact-text text-white">
                      <a style={{ color: "#fff", textDecoration: "none" }} href="https://maps.app.goo.gl/2qGi1S3R9yyyG6GN6" target="_blank" rel="noopener noreferrer">
                        Office number 419 Amanora Chambers Magarpatta, Hadapsar, Pune 411028, Maharashtra.
                      </a>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-phone-alt" style={{ transform: "rotate(90deg)" }}></i>
                    </div>
                    <div className="contact-text">
                      <a href="tel:+919175476370" className="text-white text-decoration-none">+91 9175476370</a>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="contact-text">
                      <a href="mailto:info@digiopenservices.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">info@digiopenservices.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <marquee width="100%" direction="left" height="30px" behavior="scroll" scrollamount="4">
            <div className="marquee-content">
              <i className="fas fa-envelope"></i>
              Get in Touch With Us To Digitalise Your Business At :
              <span style={{ color: "#fbfcfe", fontWeight: "bold", margin: "0 5px" }}>
                <a href="mailto:info@digiopenservices.com" style={{ color: "#fbfcfe" }}>info@digiopenservices.com</a>
              </span>
              <i className="fas fa-phone-alt" style={{ transform: "none" }}></i>
              <span style={{ marginLeft: "15px" }}>
                <a href="tel:+919175476370" target="_blank" title="Call Now" style={{ color: "#fbfcfe" }}>Call Us: +91 9175476370</a>
              </span>
              <i className="fas fa-arrow-right" style={{ marginLeft: "15px" }}></i>
            </div>
          </marquee>
        </div>
      </div>

      <button className="enquire-float" onClick={openModal}>
        <i className="fas fa-comment-dots me-2"></i>
        Enquire Now
      </button>

      <a href="https://wa.me/919175476370" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-whatsapp"></i>
      </a>

      <div className="copyright text-center text-white py-3">
        <p className="mb-0" style={{ color: "#898ca3" }}>
          © 2026 Copyright Development By
          <a href="https://www.digiopenservices.com/" className="text-white fw-bold ms-1" style={{ textDecoration: "none" }} target="_blank" rel="noopener noreferrer">
            DigiOpen Services
          </a>
        </p>
      </div>

      {isModalOpen && (
        <div className="form-modal" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <i className="fas fa-times"></i>
            </button>

            <div className="container mb-5 mt-5">
              <div className="form-wrapper">
                <div className="form-decoration">
                  <div className="decoration-circle circle-1"></div>
                  <div className="decoration-circle circle-2"></div>
                  <div className="decoration-circle circle-3"></div>
                </div>

                <form ref={form} onSubmit={sendEmail} className="attractive-form">
                  <div className="form-header-section">
                    <span className="form-badge">
                      <i className="fas fa-headset"></i> Get in Touch
                    </span>
                    <h2 className="form-title">Let's Start a Conversation</h2>
                  </div>

                  <div className="form-row three-columns">
                    <div className="form-group">
                      <label className="form-label">
                        <i className="fas fa-user"></i> Full Name <span className="required">*</span>
                      </label>
                      <input type="text" name="name" className="form-input" placeholder="John Doe" required />
                      <div className="input-focus-border"></div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        <i className="fas fa-building"></i> Organization <span className="required">*</span>
                      </label>
                      <input type="text" name="organization" className="form-input" placeholder="Company Name" required />
                      <div className="input-focus-border"></div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        <i className="fas fa-envelope"></i> Work Email <span className="required">*</span>
                      </label>
                      <input type="email" name="email" className="form-input" placeholder="hello@company.com" required />
                      <div className="input-focus-border"></div>
                    </div>
                  </div>

                  <div className="form-row two-columns">
                    <div className="form-group">
                      <label className="form-label">
                        <i className="fas fa-phone-alt" style={{ transform: "rotate(90deg)" }}></i> Phone Number <span className="required">*</span>
                      </label>
                      <input type="tel" name="mobile" className="form-input" placeholder="+91 98765 43210" required />
                      <div className="input-focus-border"></div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        <i className="fas fa-paperclip"></i> Attachment (Optional)
                      </label>
                      <div className="file-upload-wrapper">
                        <input type="file" name="attachment" className="file-input" id="fileUpload" onChange={handleFileChange} />
                        <label htmlFor="fileUpload" className="file-label">
                          <i className="fas fa-cloud-upload-alt"></i> Choose file
                        </label>
                        {fileName && (
                          <div className="file-name">
                            <i className="fas fa-file"></i> {fileName}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group full-width">
                      <label className="form-label">
                        <i className="fas fa-comment-dots"></i> Brief Requirements / Message <span className="required">*</span>
                      </label>
                      <textarea name="brief" className="form-textarea" placeholder="Tell us about your project, goals, and requirements..." rows="2" required></textarea>
                      <div className="input-focus-border"></div>
                    </div>
                  </div>

                  {submitStatus === "success" && (
                    <div className="toast-message success">
                      <i className="fas fa-check-circle"></i> Message sent successfully! We'll contact you soon.
                    </div>
                  )}
                  {submitStatus === "error" && (
                    <div className="toast-message error">
                      <i className="fas fa-exclamation-circle"></i> Something went wrong. Please try again.
                    </div>
                  )}

                  <div className="form-actions">
                    <button type="button" className="btn-reset" onClick={handleReset}>
                      <i className="fas fa-redo-alt"></i> Reset
                    </button>
                    <button type="submit" className="btn-submit" disabled={isSubmitting}>
                      {isSubmitting ? (
                        <><i className="fas fa-spinner fa-spin"></i> Sending...</>
                      ) : (
                        <><i className="fas fa-paper-plane"></i> Send Message</>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;